import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IonicModule } from '@ionic/angular';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from "../environments/environment";
import { ComponentsModule } from './components/components.module';
import { GlobalComponentsModule } from './components/global/global-components.module';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from "@angular/common/http";
import { InterceptorService } from "./service/interceptors/interceptor.service";
import { IonicStorageModule } from '@ionic/storage-angular';
import { MatIconModule } from "@angular/material/icon";

import { File } from '@awesome-cordova-plugins/file/ngx';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
// import { IonicSelectableModule } from "ionic-selectable";
import { IonicSelectableComponent, IonicSelectableAddItemTemplateDirective } from 'ionic-selectable';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import {IStepOption, TourAnchorMatMenuDirective, TourMatMenuModule, TourService} from 'ngx-ui-tour-md-menu';
import {RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import { NgChartsModule  } from 'ng2-charts';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { JoyrideModule } from "ngx-joyride";
import { LottieModule, provideCacheableAnimationLoader, provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginatorIntl } from './components/custom-paginator-intl';
import { IdByBrandInterceptor } from './service/interceptors/id-by-brand.interceptor';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { languageInterceptor } from './service/interceptors/language.interceptor';
import { PerformanceMockInterceptor } from './service/modulo-desempeno/mock/performance-mock.interceptor';
import { MediaCapture } from '@awesome-cordova-plugins/media-capture/ngx';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import {   CalendarEvent,
  CalendarView,
  CalendarMonthViewComponent,
  CalendarWeekViewComponent,
  CalendarDayViewComponent,
   } from 'angular-calendar';

import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
import { registerLocaleData } from '@angular/common';

// Registrar locales de Angular
registerLocaleData(localeEs, 'es');
registerLocaleData(localeEn, 'en');

export function playerFactory() {
  return player;
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/app/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    IonicModule.forRoot({
      innerHTMLTemplatesEnabled: true,
    }),
    IonicStorageModule.forRoot(),
    JoyrideModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: false,
      // enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      // registrationStrategy: 'registerWhenStable:30000'
    }),
    HttpClientModule,
    ComponentsModule,
    GlobalComponentsModule,
    MatIconModule,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    // MatCardModule,
    NgChartsModule,
    IonicSelectableComponent,
    IonicSelectableAddItemTemplateDirective,
    NgxExtendedPdfViewerModule,
      //  MatDatepickerModule,
      //   MatNativeDateModule,
    LottieModule.forRoot({ player: playerFactory }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        // useFactory: (http: HttpClient) => new LazyTranslateLoader(http, 'global'),
        // useFactory: (http: HttpClient) => new TranslateStaticLoader(http, 'app/common/i18n', '.json'),
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      },
      // defaultLanguage: 'es'
      // isolate: false // Permite compartir traducciones entre módulos
      isolate: false,
      // extend: true,

    }),
     CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
      // CalendarMonthViewComponent,
      //   CalendarWeekViewComponent,
      //   CalendarDayViewComponent,
  ],
  providers: [
    // IonicSelectableModule,
    {
			provide: HTTP_INTERCEPTORS,
			useClass: InterceptorService,
			multi: true,
		},
    {
			provide: HTTP_INTERCEPTORS,
			useClass: IdByBrandInterceptor,
			multi: true,
		},
    {
			provide: HTTP_INTERCEPTORS,
			useClass: languageInterceptor,
			multi: true,
		},
		// Simulador de API del módulo de desempeño (mock backend mientras el backend
		// real está en desarrollo). Se desactiva con MOCK_PERFORMANCE_API: false.
		{
			provide: HTTP_INTERCEPTORS,
			useClass: PerformanceMockInterceptor,
			multi: true,
		},
    File,
		AndroidPermissions,
    provideAnimations(),
    InAppBrowser,
    { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
    MediaCapture
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
